<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  modelValue: boolean;
  imageUrl: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const imageName = computed(() => {
  if (!props.imageUrl) {
    return '';
  }
  return (props.imageUrl.split('/').pop() || 'catalogue image').split('?')[0];
});

const handleClose = () => {
  emit('update:modelValue', false);
};

const handleKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    handleClose();
  }
};
</script>

<template>
  <v-dialog
    :model-value="props.modelValue"
    max-width="50vw"
    @update:model-value="$emit('update:modelValue', $event)"
    @keydown="handleKeydown"
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" @click="handleClose" />
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <div class="d-flex align-center justify-center pa-6">
          <v-img :src="imageUrl" :alt="imageName" contain class="rounded" />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
